import uuidv4 from "uuid/v4";
import * as types from "./types";

const ERROR_NOTIFICATION_TIME = 5000;
const SUCCESS_NOTIFICATION_TIME = 2500;

function removeNotification(id) {
  return {
    id: id,
    type: types.REMOVE_NOTIFICATION,
  };
}

export function showErrorNotification(message) {
  return dispatch => {
    const id = uuidv4();

    dispatch({
      id,
      message,
      type: types.SHOW_ERROR_NOTIFICATION,
    });

    setTimeout(() => dispatch(removeNotification(id)), ERROR_NOTIFICATION_TIME);

    return id;
  };
}

export function showSuccessNotification(message) {
  return dispatch => {
    const id = uuidv4();

    dispatch({
      id,
      message,
      type: types.SHOW_SUCCESS_NOTIFICATION,
    });

    setTimeout(
      () => dispatch(removeNotification(id)),
      SUCCESS_NOTIFICATION_TIME
    );

    return id;
  };
}



// WEBPACK FOOTER //
// ./src/actions/notifications/index.js